<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure-t">Your<br class="calibre1"/><span class="char-style-override">Next<br class="calibre1"/>Level<br class="calibre1"/></span>Life</p>
<div class="calibre2" id="calibre_pb_0"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// YourNextLevelLife_split_000.vue?11ad8bda